import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { FileModel } from '@core/models/file.model';
import { ContextMenuItemComponent } from '@ux/components/context-menu/context-menu-item/context-menu-item.component';
import { ContextMenuComponent } from '@ux/components/context-menu/context-menu.component';
import { PreviewFileComponent } from '@ux/components/preview-file/preview-file.component';
import { PreviewImageComponent } from '@ux/components/preview-image/preview-image.component';
import { UploadImageComponent } from '@ux/components/upload-image/upload-image.component';
import { FilterByPipe } from '@ux/pipes/filter/filter-by.pipe';
import * as _ from 'lodash';
import { NgClickOutsideDelayOutsideDirective } from 'ng-click-outside2';

@Component({
  selector: 'app-task-view-files',
  templateUrl: './task-view-files.component.html',
  styleUrls: ['./task-view-files.component.less'],
  imports: [
    ContextMenuComponent,
    ContextMenuItemComponent,
    PreviewImageComponent,
    PreviewFileComponent,
    UploadImageComponent,
    FilterByPipe,
    NgClickOutsideDelayOutsideDirective,
  ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskViewFilesComponent {
  @ViewChild('inputUploadFiles') inputUploadFiles: any;

  @Input()
  set files(files) {
    this.filesList = files;
  }

  @Input()
  set loadingFiles(files) {
    this.loadingFilesList = files;
  }

  @Output() onFileUpload = new EventEmitter<EventTarget>();
  @Output() onFileDelete = new EventEmitter<FileModel>();

  isShowMenu = false;
  filesList = [];
  loadingFilesList = [];

  onStopUploadAndDeleteFile(file: any) {
    const index = _.findIndex(this.loadingFilesList, { name: file.name });
    this.loadingFilesList[index].subscription.unsubscribe();
    this.loadingFilesList.splice(index, 1);
  }

  onDeleteFile(file: FileModel): void {
    this.onFileDelete.emit(file);
  }

  toggleMenu() {
    this.isShowMenu = !this.isShowMenu;
  }

  onClose() {
    this.isShowMenu = false;
  }
}
